import { roboto } from '@/utils/fonts'
import styled from '@emotion/styled'

export const StyledParagraph = styled.p`
  color: rgb(255, 255, 255);
  font-family: ${roboto}, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 115%;
  width: 90%;
`
